import broadcast from './broadcast';
import templates from '@/router/main/templates';
import dropShipping from '@/router/main/dropShipping';

export default [
    {
        path: '/marketing',
        name: 'marketing',
        meta: {
            access: ['AUTH_MASS_SENDING'],
            title: 'marketing',
            icon: 'icon-guangbo',
            notPageView: true,
        },
        component: () => import(/* webpackChunkName: "marketing" */ '@/views/main/Layout.vue'),
        // redirect: { name: 'marketing_broadcast' },
        children: [
            ...broadcast,
            ...dropShipping,
            ...templates,
            // 分流链接
            {
                path: 'split_link',
                name: 'marketing_split_link',
                meta: {
                    access: ['AUTH_SPLIT_LINK'],
                    title: 'marketing_split_link',
                    icon: 'icon-zidonghua',
                },
                component: () => import(/* webpackChunkName: "split_link" */ '@/views/main/automation/SplitLink/index.vue'),
            },
            {
                path: 'insight/:id',
                name: 'marketing_split_link_insight',
                meta: {
                    access: ['AUTH_SPLIT_LINK'],
                    title: 'marketing_split_link',
                    icon: 'icon-zidonghua',
                    hideInMenu: true,
                },
                props: (route: any) => {
                    return {
                        ...route.query,
                        ...route.params,
                    };
                },
                component: () => import(/* webpackChunkName: "split_link" */ '@/views/main/automation/SplitLink/Insight/index.vue'),
            },
            /* 废弃路由，待移除 start */
            {
                path: 'plan',
                name: 'marketing_plan',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_EMAIL_GROUP'],
                    title: 'marketing_plan',
                    icon: 'icon-guangbo',
                },
                redirect: { name: 'marketing_plan_list' },
                component: () => import(/* webpackChunkName: "marketing" */ '@/views/main/broadcast/dropshipping/index.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'marketing_plan_list',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_EMAIL_GROUP'],
                            title: 'marketing_plan_list',
                            icon: 'icon-guangbo',
                        },
                        redirect: { name: 'drop_shipping_edm_list' },
                    },
                    {
                        path: 'order/:id*',
                        name: 'marketing_plan_order',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_EMAIL_GROUP'],
                            title: 'marketing_plan_order',
                            icon: 'icon-guangbo',
                        },
                        component: () => import(/* webpackChunkName: "marketing" */ '@/views/main/marketing/plan/Order.vue'),
                    },
                    {
                        path: 'detail',
                        name: 'marketing_plan_detail',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_EMAIL_GROUP'],
                            title: 'marketing_plan_detail',
                            icon: 'icon-guangbo',
                        },
                        redirect: { name: 'drop_shipping_edm_detail_sent' },
                        children: [
                            {
                                path: 'order/:id*',
                                name: 'marketing_plan_detail_order',
                                meta: {
                                    access: ['AUTH_EMAIL_GROUP'],
                                    title: 'marketing_plan_detail_order',
                                    icon: 'ios-list',
                                },
                                redirect: { name: 'drop_shipping_edm_detail_sent' },
                            },
                            {
                                path: 'sent/:id',
                                name: 'marketing_plan_sent',
                                meta: {
                                    access: ['AUTH_EMAIL_GROUP'],
                                    title: 'marketing_plan_sent',
                                    icon: 'ios-list',
                                },
                                redirect: { name: 'drop_shipping_edm_detail_sent' },
                            },
                        ],
                    },
                    {
                        path: 'edit/:id*',
                        name: 'marketing_plan_edit',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_EMAIL_GROUP'],
                            title: 'marketing_plan',
                            icon: 'icon-guangbo',
                        },
                        redirect: { name: 'drop_shipping_edm_edit' },
                        // component: () => import(/* webpackChunkName: "marketing" */ '@/views/main/marketing/plan/Edit/index.vue'),
                    },
                ],
            },
            /* 废弃路由，待移除 end */
        ],
    },
];
